export const REQUEST_PROFILE = "request_profile"
export const PROFILE_SUCCESS = "profile_success"
export const PROFILE_FAILURE = "profile_failure"

export const CLEAR_PROFILE = "clear_profile"